import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ThemeProvider } from './lib/ThemeContext.tsx';

// Initialize page view tracking for development URLs
const trackDevPageView = () => {
  try {
    const currentHostname = window.location.hostname;
    const knownDevURLs = [
      'zp1v56uxy8rdx5ypatb0ockcb9tr6a-oci3-nuegj1mr',
      'sb1qykhapp2-1y2q',
      'zp1v56uxy8rdx5ypatb0ockcb9tr6a-oci3-m6gkswig',
      'zp1v56uxy8rdx5ypatb0ockcb9tr6a-oci3'
    ];
    
    if (knownDevURLs.some(url => currentHostname.includes(url)) || 
        currentHostname.includes('local-credentialless.webcontainer')) {
      
      // Send page view event to dataLayer
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'page_view',
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
          page_hostname: currentHostname
        });
      }
      
      // Send to GA4 directly
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
          send_to: 'G-R8PK1JKCNT'
        });
      }
    }
  } catch (error) {
    console.warn('Error tracking page view:', error);
  }
};

// Track page view on initial load
trackDevPageView();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);